import moment from 'moment';
import {
  bagNames,
  getFareType,
  getDtd,
  passengerCount,
  sortAlphabetically,
  getAncillaryNameInsurance,
} from '../../../../utilities/helpers';
import { sendAncillaryAddToCartEvent } from '../../../../utilities/customer-io-ancillary-events';
import { CARRY_ON_LABELS } from './constants';

export default (products, pnrModel, userProfile, isActiveFlowCorporate, userCorporate) => {
  const items = [];
  let tripType = 'MC';
  const segments = [];
  let zone = 'NA';
  const legCollection = pnrModel?.legCollection;
  const outboundSegments = legCollection?.[0]?.segmentsCollection;
  const inboundSegments = legCollection?.[legCollection?.length - 1]?.segmentsCollection;
  let fopType = 'NA';
  let stopNumbers = 0;

  if (pnrModel?.flightItineraryType === 'ONEWAY') {
    tripType = 'OW';
  } else if (pnrModel?.flightItineraryType === 'ROUNDTRIP') {
    tripType = 'RT';
  }

  if (legCollection.length > 0) {
    legCollection.forEach((element) => {
      const data = element?.segmentsCollection;
      stopNumbers = data?.length > 1 ? stopNumbers + (data.length - 1) : 0; 
      data.map((segmentsData) => {
        segments.push(segmentsData);
      });
    });
  }

  const apiDepartureDate = moment(segments?.[0]?.departureDateTime);
  const transactionDate = moment(pnrModel?.creationDate);
  const apiItem = apiDepartureDate.diff(transactionDate, 'days');
  const dtd = getDtd(segments?.[0]?.departureDateTime);

  const inboundDepartureDate = pnrModel?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') : 'NA';
  const inboundArrivalDate = pnrModel?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[inboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';

  const arrivalAirport = outboundSegments?.[outboundSegments?.length - 1]?.arrivalAirport || 'NA';
  const departureAirport = outboundSegments?.[0]?.departureAirport || 'NA';
  const inboundArrivalAirport = inboundSegments?.[inboundSegments?.length - 1]?.arrivalAirport || 'NA';
  const inboundDepartureAirport = inboundSegments?.[0]?.departureAirport || 'NA';
  const marketOd = `${departureAirport}${arrivalAirport}`;
  let marketNdod = `${arrivalAirport}${departureAirport}` || 'NA';
  const outboundName = marketOd;
  const inboundName =  `${inboundDepartureAirport}${inboundArrivalAirport}`;

  if (departureAirport < arrivalAirport) {
    marketNdod = `${departureAirport}${arrivalAirport}` || 'NA';
  }

  const outboundDepartureDate = outboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') || 'NA';
  const outboundArrivalDate = outboundSegments?.[outboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD');

  const mcOutBoundDepartureDate = (legCollection || []).map((legData) => {
    const firstSegment = legData?.segmentsCollection[0] || [];
    const departureDate = firstSegment?.departureDateTime?.format('YYYYMMDD') || 'NA';
    return departureDate;
  }).join('-');

  const mcOutBoundArrivalDate = (legCollection || []).map((legData) => {
    const lastSegment = legData?.segmentsCollection[legData?.segmentsCollection?.length - 1] || [];
    const arrivalDate = lastSegment?.arrivalDateTime?.format('YYYYMMDD') || 'NA';
    return arrivalDate;
  }).join('-');

  const apItemRanges = [
    { min: 0, max: 2, range: '0 a 2' },
    { min: 3, max: 6, range: '3 a 6' },
    { min: 7, max: 13, range: '7 a 13' },
    { min: 14, max: 20, range: '14 a 20' },
    { min: 21, max: 27, range: '21 a 27' },
    { min: 28, max: 49, range: '28 a 49' },
    { min: 50, max: 89, range: '50 a 89' },
    { min: 90, max: 119, range: '90 a 119' },
    { min: 120, max: 149, range: '120 a 149' },
    { min: 150, max: Infinity, range: '150+' },
  ];
  
  const apItemRange = apItemRanges.find(({ min, max }) => apiItem >= min && apiItem <= max)?.range || 'NA';

  let msItem = 0;
  if (segments.length > 1) {
    const firstSegment = moment(segments?.[0]?.departureDateTime);
    const lastSegment = moment(segments?.[segments.length - 1]?.arrivalDateTime);
    msItem = tripType !== 'MC' ? lastSegment.diff(firstSegment, 'days') : 0;
  }

  let marketSegment = [];
  const marketTest = [];
  const bookingClassTest = [];
  const cabinClassTest = [];
  (legCollection || []).forEach((element) => {
    const segmentsInfo = element?.segmentsCollection;
    const tmpMarketSegmet = [];
    const bookingClass = [];
    const cabinClass = [];
    (segmentsInfo || []).forEach((segmentsData) => {
      tmpMarketSegmet.push(`${segmentsData?.departureAirport}${segmentsData?.arrivalAirport}`);
      bookingClass.push(segmentsData?.bookingClass || 'NA');
      cabinClass.push(segmentsData?.cabin || 'NA');
    });
    marketTest.push(tmpMarketSegmet.join('/'));
    bookingClassTest.push(bookingClass.join('/'));
    cabinClassTest.push(cabinClass.join('/'));
  });
  marketSegment = marketTest.join('-');
  const bookingClassSegment = bookingClassTest.join('-');
  const cabinClassSegment = cabinClassTest.join('-');

  const travelerCollection = pnrModel?.cart?.travelerCollection || [];

  const ffNumber = userProfile?.ffNumber ? `${userProfile?.ffNumber}` : 'NA';
  let ffProgram = 'NA';
  travelerCollection.forEach(passenger => {
    if (passenger?.frequentFlyerNumber === ffNumber) {
      ffProgram = passenger?.frequentFlyerProgram;
    }
  });

  const corpProgram = isActiveFlowCorporate ? 'AM Rewards Business' : 'NA';
  let corpId = 'NA';
  const companySelected = userCorporate?.companySelected;
  (userCorporate?.companies?.companies || []).forEach(company => {
    corpId = company?.companyName === companySelected ? company?.companyLoyaltyNumber : corpId;
  });

  const ancillaries = pnrModel?.getAllUnPaidAncillaries();
  const upgFilterAncillariesArray = (ancillaries || []).filter(( { ancillary } ) => ancillary?.type === 'UPG');
  const nonUpgFilterAncillariesArray = (ancillaries || []).filter(( { ancillary } ) => ancillary?.type != 'UPG');
  const ancillariesArray = nonUpgFilterAncillariesArray?.map(({ ancillary, legCode, segmentCode }) => ({ redeemedCP: ancillary?.redeemedCP, segmentCode: segmentCode, commercialName: ancillary?.commercialName, type: ancillary?.type, totalCPPoints: ancillary?.currency?.totalCPPoints, total: ancillary?.currency?.total, legCode: legCode }));
  const upgAncillariesArray = (upgFilterAncillariesArray || []).map(( { ancillary }) => ({ redeemedCP: ancillary?.redeemedCP, segmentCode: ancillary?.segmentCode, commercialName: 'UPG', type: ancillary?.ancillaryOffer?.ancillary?.type, totalCPPoints: ancillary?.ancillaryOffer?.ancillary?.currency?.totalCPPoints, total: ancillary?.ancillaryOffer?.ancillary?.currency?.total }));
  const allAncillaries = [...ancillariesArray, ...upgAncillariesArray];
  let fopTpeItem = 'Cash';

  const travelerCount = passengerCount(travelerCollection);

  if (pnrModel?.globalMarketFlight === 'DOMESTIC') {
    zone = 'DOM';
  } else {
    zone = 'INT';
  }
  let totalPrice = 0;
  let totalPoints = 0;
  let mcPrice = 0;

  (products?.products || []).forEach((product) => {
    const productId = product?.id;
    const baggageId = ['0IA', '0CD', '0CE', '0CF', '0CG', '0CH', '0CI', '0LX', '0JH', '0LL', '02T', 'XB5', 'XB6', 'XB7'];
    const baggage = baggageId?.includes(productId);
    let itemBrand = 'AM';
    let itemCategory = 'Ancillary';
    const seatTypes = ['AMPlus Seat', 'Emergency Exit Seat', 'Preferred Seat', 'Seat Choice'];
    const seat = seatTypes?.includes(product?.name);
    let itemAffiliation = 'AM';
    let itemCategory2 = 'NA';
    let itemCategory3 = 'NA';
    let price = 0;
    let quantity = 0;
    let itemListName = 'NA';
    let aircraftType = 'NA';
    let mcFlightTime = 0;
    let aircraftSubfleet = 'NA';
    let cabinItem = 'NA';
    let classItem = 'NA';
    let marketSegmentsItem = 'NA';
    let inboundDepartureDateItem = 'NA';
    let outboundDepartureDateItem = 'NA';
    const leg = product?.category;
    let currentAncillary = (allAncillaries || []).find((produc) => produc.type === productId);
    fopTpeItem = currentAncillary?.redeemedCP ? 'Points' : 'Cash';
    switch (productId) {
      case 'SVI':
        itemCategory = 'Insurance';
        itemCategory2 = getAncillaryNameInsurance(productId);
        itemAffiliation = 'AM';
        price = product?.price;
        quantity = product?.quantity;
        itemBrand = 'CHUBB';
        break;
      case 'AMK':
        itemCategory = 'Services';
        itemCategory2 = 'Concierge';
        itemCategory3 = 'NA';
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Services outbound' :
          'Services outbound and services inbound';
        break;
      case 'DPM':
      case 'DPI':
        itemCategory = 'Services';
        itemCategory2 = 'Discount Pass ';
        itemCategory3 = pnrModel?.globalMarketFlight === 'DOMESTIC' ? 'MEXICO' : 'INTERNATIONAL';
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Services outbound' :
          'Services outbound and services inbound';
        break;
      case '09T':
        itemCategory = 'Services';
        itemCategory2 = 'Fly Green';
        itemCategory3 = 'NA';
        price = product?.price;
        quantity = product?.pax;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
          'Ancillaries outbound ancillaries inbound';
        break;
      case '07X':
        itemCategory2 = CARRY_ON_LABELS.CARRY_ON;
        itemCategory3 = CARRY_ON_LABELS.CARRY_ON_PLUS_5KG;
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
          'Ancillaries outbound ancillaries inbound';
        break;
      case '0CZ':
        itemCategory2 = CARRY_ON_LABELS.CARRY_ON;
        itemCategory3 = CARRY_ON_LABELS.CARRY_ON_10KG;
        price = product?.price;
        quantity = product?.quantity;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
          'Ancillaries outbound ancillaries inbound';
        break;
      case 'CBX':
        itemCategory2 = 'CBX';
        itemCategory3 = 'NA';
        price = product?.price;
        break;
      case 'U87':
      case 'UPG':
        itemCategory = 'Upgrade';
        itemCategory2 = segments?.[0]?.fareFamily;
        quantity = product?.quantity;
        price = product?.price;
        itemListName = (tripType === 'OW' || tripType === 'MC') ? 'upgrade outbound' :
          'Upgrade outbound upgrade inbound';
        break;
      default:
        if (seat) {
          itemCategory2 = 'Seat';
          itemCategory3 = product?.name + '|' + product?.id;
          price = product?.price;
          quantity = product?.quantity;
          break;
        }
    }

    if (baggage) {
      itemCategory2 = 'Luggage';
      const productname = product?.name;
      const split = productname?.split('/');
      const bagName = split?.[0];
      itemCategory3 = bagNames(bagName);
      price = product?.price;
      quantity = product?.quantity;
      itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' :
        'Ancillaries outbound ancillaries inbound';
    }

    itemCategory = itemCategory?.trim();
    itemCategory2 = itemCategory2?.trim();
    itemCategory3 = itemCategory3?.trim();
    const luggageItems = ['Luggage', 'hand luggage'];
    const isBaggage = luggageItems?.includes(itemCategory2);

    if (product?.quantity && !isBaggage && itemCategory2 != 'CBX' && itemCategory2 != 'Fly Green') {
      const segmentPrice = fopTpeItem === 'Points' ? product?.points * quantity : price * quantity;
      if (currentAncillary?.redeemedCP) {
        totalPoints += segmentPrice; 
      } else {
        totalPrice += segmentPrice;
      }
    }

    let pricePoint = currentAncillary?.redeemedCP ? currentAncillary?.totalCPPoints / product?.quantity : 0;
    if (currentAncillary?.redeemedCP) {
      price = 0;
    }

    legCollection.forEach((legs, legIndex) => {
      const ancillaries = ['Concierge', 'Insurance', 'Discount Pass'];   
      const upgradeItemName = ['Upgrade'];
      const cbxItem = ['CBX'];
      const flyGreenItem = ['Fly Green'];
      const ancillaryIncluded = itemCategory === 'Insurance' ? ancillaries?.includes(itemCategory) : ancillaries?.includes(itemCategory2);
      const isFlyGreen = flyGreenItem.includes(itemCategory2);
      const isCBX = cbxItem.includes(itemCategory2);
      currentAncillary = isCBX ? (allAncillaries || []).find((produc) => produc?.legCode === legs?.legCode) : 
        isBaggage ? (allAncillaries || []).find((produc) => produc?.legCode === legs?.legCode && productId === produc.type) : currentAncillary;
      let isSameLegCode = legs?.legCode === currentAncillary?.legCode;
      let nameToCompare = legs?.itineraryPartType === 'OUTBOUND' ? outboundName : inboundName;
      const firstSegments = legs?.segmentsCollection?.[0];
      const lastSegments = legs?.segmentsCollection?.[legs?.segmentsCollection?.length - 1];
      const lastSegmentsAirport = lastSegments?.arrivalAirport || 'NA';
      const firstSegmentsAirport = firstSegments?.departureAirport || 'NA';
      nameToCompare = tripType === 'MC' ? `${firstSegmentsAirport}${lastSegmentsAirport}` : nameToCompare;

      if (isBaggage && isSameLegCode) {
        fopTpeItem = currentAncillary?.redeemedCP ? 'Points' : 'Cash';
        pricePoint = currentAncillary?.redeemedCP ? currentAncillary?.totalCPPoints : 0;
        price = currentAncillary?.redeemedCP ? 0 : currentAncillary?.total;
        quantity = (allAncillaries || []).filter((produc) => produc?.legCode === legs?.legCode && productId === produc.type).length;
      }

      if (isCBX && isSameLegCode) {      
        const index2 = items?.findIndex((item) => item?.item_name === nameToCompare);
        if (index2 !== -1) return;
        quantity = (allAncillaries || []).filter((produc) => produc?.legCode === legs?.legCode).length;
        price = currentAncillary?.total;
      }

      if ((isBaggage || isCBX) && !isSameLegCode) {
        return;
      }

      if (ancillaryIncluded && (legs?.itineraryPartType === 'OUTBOUND' || legIndex === 0) && product?.quantity) {
        (legs?.segmentsCollection || []).forEach((passenger, index) => {
          if (index > 0) return;
          const departureDateTime = moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss');
          const opCarrier = passenger?.operatingCarrier;
          const flightTime = moment?.utc(legs?.totalFlightTimeInMinutes * 60000).format('HH:mm');
          const brandFare = getFareType(passenger);
          const params = {
            'item_name': marketOd || 'NA',
            'coupon': 'NA',
            'discount': 0,
            'item_brand': itemBrand,
            'item_category': itemCategory,
            'item_category2': itemCategory2,
            'item_category3': itemCategory3,
            'item_list_name': itemListName,
            'item_affiliation': itemAffiliation,
            'price': price,
            'quantity': quantity,
            'index': index,
            'market_ndod_item': marketNdod || 'NA',
            'market_od_item': marketOd || 'NA',
            'market_segment_item': marketSegment,
            'zone_item': passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT' || 'NA',
            'region_item': passenger?.regionKeyFromLeg || 'NA',
            'flight_time_dep': departureDateTime || 'NA',
            'flight_time': flightTime || 'NA',
            'branded_fare': brandFare,
            'upsell_amount': 0,
            'outbound_departure_date_item': outboundDepartureDate || 'NA',
            'inbound_departure_date_item': inboundDepartureDate,
            'fop_type_item': fopTpeItem,
            'price_points': pricePoint,
            'airport_tax': pnrModel?.cart?.total?.taxDetails?.TUA || 0,
            'aircraft_type': passenger?.aircraftType || 'NA',
            'aircraft_subfleet': `${opCarrier}${passenger?.aircraftType}` || 'NA',
            'ap_item': apItemRange,
            'ms_item': msItem,
            'cabin_item': passenger?.cabin || 'NA',
            'class_item': passenger?.bookingClass || 'NA',
          };
          items.push(params);
        });
      } else if (!ancillaryIncluded && product?.quantity) {
        const connectedFlights = legs?.legType === 'CONNECTING' && baggage ? [legs?.segmentsCollection?.[0]] : legs?.segmentsCollection;
        (connectedFlights).forEach((passenger, index) => {
          const departureDateTime = moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss');
          const flightTime = moment?.utc(passenger?.flightDurationInMinutes * 60000).format('HH:mm');
          const marketOdItem = `${passenger?.departureAirport}${passenger?.arrivalAirport}`;
          let marketNdodItem = sortAlphabetically(passenger?.arrivalAirport, passenger?.departureAirport) || 'NA';
          const segment = passenger?.departureAirport + '-' + passenger?.arrivalAirport;
          const opCarrier = passenger?.operatingCarrier;
          const brandFare = getFareType(passenger);
          itemListName = legs.itineraryPartType === 'OUTBOUND' ? 'Ancillaries outbound' : 'Ancillaries inbound';
          itemListName = tripType === 'MC' ? 'Ancillaries outbound' : itemListName;
          const connectingFlights = legs?.segmentsCollection;
          let segmentCheck = false;
          if (leg?.includes(segment)) {
            segmentCheck = true;
          } else if (leg?.includes(connectingFlights?.[0]?.departureAirport + '-' + connectingFlights?.[connectingFlights?.length - 1]?.arrivalAirport)) {
            segmentCheck = true;
          }
          const isUpgrade = upgradeItemName?.includes(itemCategory);
          let itemName = marketOdItem;
          let currentUpg = null;

          if (isFlyGreen) {
            const index2 = items?.findIndex((item) => item?.item_name === itemName);
            currentAncillary = allAncillaries.find((item) => item?.segmentCode === passenger?.segmentCode && productId === item.type && item?.legCode === legs?.legCode);
            isSameLegCode = legs?.legCode === currentAncillary?.legCode;
            if (index2 !== -1 || !currentAncillary) return;
            quantity = (allAncillaries || []).filter((item) => (item?.segmentCode === passenger?.segmentCode) && productId === item.type).length;
            price = currentAncillary?.total;
          }

          if (isUpgrade) {
            currentUpg = upgAncillariesArray?.find((upg) => upg?.segmentCode === passenger?.segmentCode);
            const redeemedCP = products?.products?.find((product) => product?.segmentCode === currentUpg?.segmentCode)?.redeemedCP;
            fopTpeItem = redeemedCP ? 'Points' : 'Cash';
            pricePoint = redeemedCP ? currentUpg?.totalCPPoints : 0;
            price = redeemedCP ? 0 : currentUpg?.total;

            const index2 = items?.findIndex((item) => item?.item_name == marketOdItem);       
            if (!currentUpg || index2 != -1) return;
            itemListName = legs.itineraryPartType == 'OUTBOUND' ? 'Upgrade outbound' : 'Upgrade inbound';
            itemListName = tripType === 'MC' ? 'Upgrade outbound' : itemListName;
          }

          if (isCBX) {
            if (index > 0) return;
            itemName = legs?.itineraryPartType == 'OUTBOUND' ? outboundName : inboundName;
            itemName = tripType === 'MC' ? `${firstSegmentsAirport}${lastSegmentsAirport}` : itemName;
            itemListName = (tripType === 'OW' || tripType === 'MC') ? 'Ancillaries outbound' : itemListName;
          }

          if ((baggage || isCBX) && legs.legType === 'CONNECTING') {
            marketSegmentsItem = (connectingFlights || []).map((segment) => {
              return `${segment?.departureAirport || 'NA'}${segment?.arrivalAirport || 'NA'}`;
            }).join('/');
          }

          if (baggage && legs.legType === 'CONNECTING') {
            mcPrice = 0; 
            itemName = connectingFlights?.[0]?.departureAirport + connectingFlights?.[connectingFlights?.length - 1]?.arrivalAirport;
            marketNdodItem = sortAlphabetically(connectingFlights?.[connectingFlights?.length - 1]?.arrivalAirport, connectingFlights?.[0]?.departureAirport) || 'NA';
            (connectingFlights || []).forEach((segment) => {
              mcPrice +=  segment?.layoverToNextSegmentsInMinutes + segment?.flightDurationInMinutes;
            });
            mcFlightTime = moment?.utc(mcPrice * 60000).format('HH:mm');
            outboundDepartureDateItem = legs?.itineraryPartType === 'OUTBOUND' || tripType === 'MC' ? connectingFlights?.[0]?.departureDateTime?.format('YYYYMMDD') + '/' + connectingFlights?.[connectingFlights?.length - 1]?.departureDateTime?.format('YYYYMMDD') : 'NA';
            inboundDepartureDateItem = legs?.itineraryPartType === 'INBOUND' && tripType === 'RT' ? connectingFlights?.[0]?.arrivalDateTime?.format('YYYYMMDD') + '/' + connectingFlights?.[connectingFlights?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';
            aircraftType = connectingFlights?.[0]?.aircraftType + '/' + connectingFlights?.[connectingFlights?.length - 1]?.aircraftType;
            aircraftSubfleet = connectingFlights?.[0]?.operatingCarrier + connectingFlights?.[0]?.aircraftType + '/' + connectingFlights?.[connectingFlights?.length - 1]?.operatingCarrier + connectingFlights?.[connectingFlights?.length - 1]?.aircraftType;
            cabinItem = connectingFlights?.[0]?.cabin + '/' + connectingFlights?.[connectingFlights?.length - 1]?.cabin;
            classItem = connectingFlights?.[0]?.bookingClass + '/' + connectingFlights?.[connectingFlights?.length - 1]?.bookingClass;
          }

          if (pnrModel.isOnHold && legs.itineraryPartType === 'OUTBOUND') {
            itemListName = 'Flights outbound';
            itemListName = tripType == 'MC' ? 'Flights outbound' : itemListName;
          } else if (pnrModel.isOnHold && legs.itineraryPartType === 'INBOUND') {
            itemListName = 'Flights inbound';
            itemListName = tripType == 'MC' ? 'Flights outbound' : itemListName;
          }

          const flightDuration = legs.legType === 'CONNECTING' && baggage ? mcFlightTime : flightTime || 'NA';
          const marketSegmntItem = legs?.legType === 'CONNECTING' && (baggage || isCBX) ? marketSegmentsItem : marketOdItem || 'NA';
          const outbounDepartureItem = legs?.legType === 'CONNECTING' && baggage ? outboundDepartureDateItem : outboundDepartureDate || 'NA';
          const inboundDepartureItem = legs?.legType === 'CONNECTING' && baggage ? inboundDepartureDateItem : inboundDepartureDate || 'NA';
          const airCraft = legs?.legType === 'CONNECTING' && baggage ? aircraftType : passenger?.aircraftType || 'NA';
          const CraftSubfleet =  legs?.legType === 'CONNECTING' && baggage ? aircraftSubfleet : `${opCarrier}${passenger?.aircraftType}` || 'NA';
          const cabinItems = legs?.legType === 'CONNECTING' && baggage ? cabinItem : passenger?.cabin || 'NA';
          const classItems = legs?.legType === 'CONNECTING' && baggage ? classItem : passenger?.bookingClass || 'NA';

          if (productId === '09T' || productId === 'CBX') {
            segmentCheck = productId === 'CBX' || productId === '09T' ? isSameLegCode : segment === product?.segment;
          }
          const seatCheck = seat ? false : productId === 'U87' ? segmentCheck : legs?.legType === 'CONNECTING';
          if (segmentCheck || seatCheck) {
            const params = {
              'item_name': itemName || 'NA',
              'coupon': 'NA',
              'discount': 0,
              'item_brand': itemBrand,
              'item_category': itemCategory,
              'item_category2': itemCategory2,
              'item_category3': brandFare === 'MAIN_LIGHT' ? CARRY_ON_LABELS.CARRY_ON_10KG : itemCategory3,
              'item_list_name': itemListName,
              'item_affiliation': itemAffiliation,
              'price': price,
              'quantity': quantity,
              'index': index,
              'market_ndod_item': marketNdodItem || 'NA',
              'market_od_item': itemName || 'NA',
              'market_segment_item': marketSegmntItem,
              'zone_item': passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT' || 'NA',
              'region_item': passenger?.regionKeyFromLeg || 'NA',
              'flight_time_dep': departureDateTime || 'NA',
              'flight_time': flightDuration,
              'branded_fare': brandFare === 'MAIN_LIGHT' ? 'LIGHT' : brandFare,
              'upsell_amount': 0,
              'outbound_departure_date_item': outbounDepartureItem,
              'inbound_departure_date_item': inboundDepartureItem,
              'fop_type_item': fopTpeItem,
              'price_points': pricePoint,
              'airport_tax': pnrModel?.cart?.total?.taxDetails?.TUA || 0,
              'aircraft_type': airCraft,
              'aircraft_subfleet': CraftSubfleet,
              'ap_item': apItemRange,
              'ms_item': msItem,
              'cabin_item': cabinItems,
              'class_item': classItems,
            };
            items.push(params);
          }
        });
      }
    });
  });

  const updatedItems = items.filter((obj, index, item) =>
    index === item.findIndex((value) => (
      value?.price === obj?.price && value?.item_name === obj?.item_name && value?.item_category3 === obj?.item_category3 && value?.flight_time
      === obj?.flight_time
    ))
  );
  const itemSelected = (legCollection?.[0]?.legType === 'CONNECTING' || legCollection?.[legCollection?.length - 1]?.legType === 'CONNECTING') ? updatedItems : items;
  totalPrice = itemSelected?.reduce((acc, product) => {
    return acc + (product?.price * product?.quantity);
  }, 0);
  totalPoints = itemSelected?.reduce((acc, product) => {
    return acc + (product?.price_points * product?.quantity);
  }, 0);

  if (totalPoints > 0 && totalPrice > 0) {
    fopType = 'Cash+Points';
  } else if (totalPoints > 0 && totalPrice === 0) {
    fopType = 'Points';
  } else {
    fopType = 'Cash';
  }

  const result = {
    event: 'add_to_cart',
    ecommerce: {
      'currency': products?.currencyCode || pnrModel?.cart?.total?.currencyCode || 'NA',
      'value': totalPrice,
      'funnel_name': 'MYB',
      'sub_funnel_name': 'Ancillary',
      'trip_type': tripType,
      'fop_type': fopType || 'NA',
      'outbound_departure_date': tripType === 'MC' ? mcOutBoundDepartureDate : outboundDepartureDate || 'NA',
      'inbound_departure_date': inboundDepartureDate,
      'outbound_arrival_date': tripType === 'MC' ? mcOutBoundArrivalDate : outboundArrivalDate || 'NA',
      'inbound_arrival_date': inboundArrivalDate,
      'zone': zone,
      'market_od': marketOd || 'NA',
      'market_ndod': marketNdod || 'NA',
      'market_segment': marketSegment || 'NA',
      'region': legCollection?.[0]?.regionKey || 'NA',
      'value_points': totalPoints,
      'ffn_program': ffProgram,
      'ffn_id': ffNumber,
      'corp_program': corpProgram,
      'corp_id': corpId || 'NA',
      'adults': travelerCount?.adults,
      'childs': travelerCount?.child,
      'infants': travelerCount?.infants,
      'adult_minor': travelerCount?.adultMinors,
      'stops_number': stopNumbers,
      'dtd': dtd,
      'clid_benefits': 'NA',
      'cabin': cabinClassSegment || 'NA',
      'class': bookingClassSegment || 'NA',
      'items': (legCollection?.[0]?.legType === 'CONNECTING' || legCollection?.[legCollection?.length - 1]?.legType === 'CONNECTING') ? updatedItems : items,
    },
  };

  // Customer.io ancillary_addtocart event integration
  try {
    // Determine ancillary type based on products type
    let ancillaryType = 'ckdbags'; // default for baggage
    if (products?.type === 'insurance') {
      ancillaryType = 'travelinsurance';
    } else if (products?.type === 'discountpass') {
      ancillaryType = 'discountpass';
    }
    
    sendAncillaryAddToCartEvent({
      ancillaryType: ancillaryType,
      PNR: pnrModel?.pnrCode || 'Unknown',
      passengerName: pnrModel?.cart?.travelerCollection?.[0]?.firstName || '',
      passengerLastName: pnrModel?.cart?.travelerCollection?.[0]?.lastName || '',
      email: pnrModel?.cart?.travelerCollection?.[0]?.email || '',
      phone: pnrModel?.cart?.travelerCollection?.[0]?.phone || '',
      destination: legCollection?.[0]?.segmentsCollection?.[0]?.arrivalAirport || 'Unknown',
    });
  } catch (error) {
    // Silent error
  }

  return result;
};
